import type { Notification } from "../types/notification.types.ts"

// "calendarevent" is Django's plain `ContentType.model` string for
// CalendarEvent (see notifications_app/services.py's `_serialize_generic_object`)
// — there is no backend allowlist to extend, this frontend list is the only gate.
const CLICKABLE_TARGET_TYPES = [
  "project",
  "lead",
  "calendarevent",
  "subcontractor"
] as const

export function isNotificationClickable(notification: Notification): boolean {
  const type = notification?.target?.type
  return !!type && (CLICKABLE_TARGET_TYPES as readonly string[]).includes(type)
}
